export default {
  searchLabel: {
    id: 'cms-block-trade-in-search-label',
    defaultMessage: 'Search for devices',
  },
}
